import { render, staticRenderFns } from "./SpuDefaultServices.vue?vue&type=template&id=acf4ce60&scoped=true"
import script from "./SpuDefaultServices.vue?vue&type=script&lang=ts"
export * from "./SpuDefaultServices.vue?vue&type=script&lang=ts"
import style0 from "./SpuDefaultServices.vue?vue&type=style&index=0&id=acf4ce60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf4ce60",
  null
  
)

export default component.exports